"use client";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@/components/ui/dialog";

import { ImageWithFallback } from "./image";

import { formatPropertyTitle } from "@/helper/property";

import type { House, TabsEstate } from "@/types";

interface PropertyDialogProps {
  data: House;
  visible: TabsEstate | null;
  onClose: () => void;
}

export const InfoDialog = ({ data, visible, onClose }: PropertyDialogProps) => {
  const { cidade_descricao, bairro, tipo, banco } = data;

  const title = formatPropertyTitle(
    {
      tipo,
      cidade_descricao,
      bairro,
      banco,
    },
    {
      showBank: true,
      showAuction: true,
    }
  );

  return (
    <Dialog
      open={visible === "fotos"}
      onOpenChange={(value) => !value && onClose()}
    >
      <DialogContent className="overflow-auto w-full sm:max-w-5xl h-full sm:h-[95%]">
        <div className="flex flex-col gap-6">
          <div className="space-y-2">
            <DialogTitle>Fotos</DialogTitle>
            <DialogDescription className="text-sm text-muted-foreground">
              Veja todas as fotos disponíveis do imóvel pelo banco ou leiloeiro.
            </DialogDescription>
          </div>
          <div className="mt-12 flex flex-wrap gap-4">
            {data.imagens.map((href, index) => (
              <a key={index} href={href} target="_blank" rel="nofollow">
                <ImageWithFallback
                  src={href}
                  alt={`${title} - imagem ${index}`}
                  height={250}
                  width={250}
                  className="rounded-md"
                />
              </a>
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
